import { styled } from '@linaria/react';
import { RectangleSkeleton, CircleSkeleton } from '@fe-common-ui/Skeleton';

const TitleWrapper = styled.div`
  padding: 16px 16px 24px 12px;
  position: relative;
  overflow: hidden;
  margin-bottom: 27px;
  border-radius: 6px 6px 0px 0px;

  &::before {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    content: '';
    opacity: 0.6;
    position: absolute;
    background-size: cover;
    background-position: center;
  }
`;

const TitleContent = styled.div`
  position: relative;
  z-index: 1;
  color: #fff;
`;

const Title = styled.div`
  display: flex;
  min-height: 64px;
  align-items: center;
`;

const H3 = styled.h3<{ isCarousel: boolean }>`
  flex: 1;
  margin-left: ${({ isCarousel }) => (isCarousel ? '28px' : '4px')};
  margin-right: 16px;
`;

const Summary = styled.div`
  margin-top: 4px;
  padding-left: 28px;
  font-size: 14px;
  line-height: 1.71;
`;

const TagWrapper = styled.div`
  margin-top: 10px;
  padding-left: 28px;
  display: flex;
  column-gap: 8px;
`;

type PopTopicCardTitleProps = {
  isCarousel?: boolean;
};

const PopTopicCardTitle: React.FC<PopTopicCardTitleProps> = ({ isCarousel = false }) => {
  return (
    <TitleWrapper>
      <TitleContent>
        <Title>
          {!isCarousel && <CircleSkeleton width={24} height={24} />}
          <H3 isCarousel={isCarousel}>
            <RectangleSkeleton width='50%' height={24} />
          </H3>
        </Title>
        <Summary>
          <RectangleSkeleton width='50%' height={24} />
        </Summary>
        <TagWrapper>
          {Array.from({ length: 3 }).map((_, index) => (
            <RectangleSkeleton key={index} width={60} height={28} />
          ))}
        </TagWrapper>
      </TitleContent>
    </TitleWrapper>
  );
};

export default PopTopicCardTitle;
